import React from 'react';
import classnames from 'classnames';

import {excerptText} from '../styles.module.scss'

const AdditionalHero = ({ title, excerpt, subtitle }) => {

  return (
    <div className="lg:mb-12">
      <div className="sm:w-8/12 ">
        <h1 className="oc-h2 mb-4 sm:mb-6">{title}</h1>

        <div
          className={classnames(excerptText, "oc-subtitle mb-6 sm:mb-10")}
          dangerouslySetInnerHTML={{ __html: excerpt }}
        ></div>

        <p className="oc-subtitle text-pomegranate">{subtitle}</p>
      </div>
    </div>
  );
};

export default AdditionalHero;
